import axios from 'axios';

type DuplicateUsersCsvStatus = 'Active' | 'Inactive';

type DuplicateUsersCsvRow = {
  key: string;
  rosterId: string;
  matchedUserId: string;
  name: string;
  status: DuplicateUsersCsvStatus;
  keyStatus?: string;
  lockboxesAssigned?: string;
};

type ProcessedPair = {
  activeRow: DuplicateUsersCsvRow;
  inactiveRow: DuplicateUsersCsvRow;
  activeHasActiveKey: boolean;
  inactiveHasActiveKey: boolean;
  hasSupraSystemSubscription: boolean;
  reassignedInactiveSubscription: boolean;
  reassignedToUserId: string | null;
  transferredKeyFromUserId: string | null;
  transferredKeyToUserId: string | null;
  deletedInactiveUserId: string | null;
};

type ProcessDuplicateUsersReportGroup = {
  name: string;
  rows: DuplicateUsersCsvRow[];
  activeInactivePairs: ProcessedPair[];
};

type KeyTransferLog = {
  name: string;
  fromUserId: string;
  toUserId: string;
};

type ProcessDuplicateUsersReportSummary = {
  totalNameGroups: number;
  totalPairs: number;
  pairsWithSupraSubscription: number;
  keysTransferredCount: number;
  inactiveUsersDeletedCount: number;
  keyTransfers: KeyTransferLog[];
  deletedUserIds: string[];
};

export type ProcessDuplicateUsersReportResponse = {
  groups: ProcessDuplicateUsersReportGroup[];
  summary: ProcessDuplicateUsersReportSummary;
};

const processDuplicateUsersReport = async ({
  csvContent,
}: {
  csvContent: string;
}) => {
  const { data } = await axios.post<ProcessDuplicateUsersReportResponse>(
    '/roster/qa_page/duplicate_users_report',
    { csvContent },
  );

  return data;
};

export default processDuplicateUsersReport;
